import React, { useState, useEffect } from 'react'
import { Popover, Position, Menu, MenuItem, Button } from '@blueprintjs/core'
import { Omnibar } from '@blueprintjs/select'
import { useTranslation } from 'react-i18next'
// API
import { getSearch } from '../../api/search'
import { userHasMenu } from 'lib/userHasMenu'
let debounceSearch // Input delay
let search_text="" // state'nin bir adım geride kalması, bahsedilen durum alttaki linktedir.
let s_type;       // https://stackoverflow.com/questions/28773839/react-form-onchange-setstate-one-step-behind
const BPOmnibar = ({ value, onClose, onItemSelect, isOpen }) => {
  const { t } = useTranslation()
  
  const FilmOmnibar = Omnibar.ofType()
  // const [searchText, setSearchText] = useState()
  const [items, setItems] = useState([])
  const [searchQuery, setSearchQuery] = useState()
  const [loading, setLoading] = useState(t('no_result'))
  const [visibleType, setVisibleType] = useState()
  // const [searchType, setSearchType] = useState()
  const [open, setOpen] = useState(isOpen)

  const itemRenderer = (item, { modifiers, handleClick, query }) => {
    // Burada render edilen search sonucu
    if (!modifiers.matchesPredicate) {
      return null
    }
    const text = `${item.id}. ${item.text}`
    return (
      <MenuItem
        active={modifiers.active}
        disabled={modifiers.disabled}
        // label={item.text.toString()}
        key={item.pi_message}
        onClick={handleClick}
        text={highlightText(text, query)}
      />
    )
  }

  const filterItem = (query, item, _index, exactMatch) => {
    const normalizedTitle = item.text.toLowerCase()
    const normalizedQuery = query.toLowerCase()

    if (exactMatch) {
      return normalizedTitle === normalizedQuery
    } else {
      return (
        `${item.id}. ${normalizedTitle} ${item.text}`.indexOf(
          normalizedQuery
        ) >= 0
      )
    }
  }

  function escapeRegExpChars (text) {
    // eslint-disable-next-line no-useless-escape
    return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
  }

  function highlightText (text, query) {
    let lastIndex = 0
    const words = query
      .split(/\s+/)
      .filter(word => word.length > 0)
      .map(escapeRegExpChars)
    if (words.length === 0) {
      return [text]
    }
    const regexp = new RegExp(words.join('|'), 'gi')
    const tokens = []
    while (true) {
      const match = regexp.exec(text)
      if (!match) {
        break
      }
      const length = match[0].length
      const before = text.slice(lastIndex, regexp.lastIndex - length)
      if (before.length > 0) {
        tokens.push(before)
      }
      lastIndex = regexp.lastIndex
      tokens.push(<strong key={lastIndex}>{match[0]}</strong>)
    }
    const rest = text.slice(lastIndex)
    if (rest.length > 0) {
      tokens.push(rest)
    }
    return tokens
  }

  const handleItemSelect = (item) => {
    onItemSelect && onItemSelect(item)
  }

  const nextSearch =  () => {
    clearTimeout(debounceSearch)
    debounceSearch = setTimeout(() => {
      if (search_text.length > 3) {
        setLoading(t('loading'))
        makeSearch()
        }else{
          setLoading(t('min_4_char'))
        }
    }, 1000);
  }
  const makeSearch = async() =>{
    try {
      const {P_RESULT_CODE, P_RESULT_MESSAGE,RESULT } = await getSearch({ search_type: s_type, search_str: search_text })
      if (P_RESULT_CODE === 0) {
        setItems(RESULT)
        if(RESULT?.length<1){
          setLoading(t('no_result'))
        }
       
      }else{
        setLoading(P_RESULT_MESSAGE)
        // openAlert('error',true, data.P_RESULT_MESSAGE)
      }
    } catch (error) {
      setLoading(error?.message)
    }
  }
  const onChangeSearchCategory = (visible_type,search_type)=>{
    setVisibleType(t(visible_type))
    // setSearchType(search_type)
    s_type=search_type
    if(search_text.length>3){
      makeSearch()
    }
  }
  const onChange = (query, event) => {
    // setSearchText(query)
    if (event === undefined) return
    setSearchQuery(query)
    search_text = query
    nextSearch()
    // this.userInput$.next(value) // <-- this just triggers a subscriber which calls ajax and later updates state , which in turn will funnel back to this render
  }

  const popoverContent = (data) => {
    
    return (
      <Menu>
        {userHasMenu(['order_confirmations']) && 
        <MenuItem
          text={t('contracts')} onClick={() => onChangeSearchCategory('contracts',1) }
        />
        }
        {userHasMenu(['contract_list','antibody_contract_list']) &&
        <MenuItem
          text={t('orders')} onClick={() => onChangeSearchCategory('orders',2)  }
        />
        }
        {userHasMenu(['invoice']) &&
        <MenuItem
          text={t('invoices')} onClick={() => onChangeSearchCategory('invoices',3) }
        />
        }
        {userHasMenu(['delivery']) &&
        <MenuItem
          text={t('deliveries')} onClick={() => onChangeSearchCategory('deliveries',4) }
        />
        }
      </Menu>
    )
  }
  
  useEffect(() => {
    setOpen(isOpen)
    setItems([])
    // setSearchType()
    setVisibleType()
    s_type=null
    search_text=""
  }, [isOpen])

  const selectButton = (
    <Popover
      position={Position.BOTTOM} content={popoverContent()} minimal target={
        <Button
          icon='caret-down'
          text={visibleType || t('search_type')}
        />
      }
    />
  )

  return (
    <>
      <FilmOmnibar
        isOpen={open}
        noResults={<MenuItem disabled text={loading} />}
        itemPredicate={filterItem}
        itemRenderer={itemRenderer}
        onItemSelect={handleItemSelect}
        onQueryChange={onChange}
        items={items}
        placeholder={t('search')}
        resetOnSelect
        query={searchQuery}
        inputProps={{ rightElement: selectButton }}
        onClose={() => { onClose(false); setOpen(false); setSearchQuery('') }}
      />
    </>
  )
}

export default BPOmnibar
